const useEditor = (args = {}) => {
  const { uploaderFileOptions } = args;

  const createInputFile = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';

    if (uploaderFileOptions?.accept) fileInput.accept = uploaderFileOptions.accept;

    return fileInput;
  };

  const openFileUploaderPopup = (done) => {
    const input = createInputFile();

    input.click();

    input.addEventListener('change', (e) => {
      if (input.files && input.files.length > 0) {
        done(input.files[0]);
      }
    });
  };

  return {
    openFileUploaderPopup,
  };
};

export default useEditor;
